import PublicLayout from '../components/PublicLayout.jsx';
import ServicesSection from '../components/ServicesSection.jsx';

export default function ServicesPage() {
  return (
    <PublicLayout>
      <div className="h-24" />
      <ServicesSection />
    </PublicLayout>
  );
}
